import { forwardRef } from 'react';
import { Grid as RadixGrid } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * Grid component - wrapper around Radix UI Grid
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type GridProps = RadixComponentProps<typeof RadixGrid>;

const Grid = forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  return <RadixGrid ref={ref} {...props} />;
});

Grid.displayName = 'Grid';

export { Grid };
